export default null;

// 현대캐피탈 회사코드 (legacy 리스승계 API leaseSuccession.companyNo 기준)
export const HYUNDAI_CAPITAL_COMPANY_NO = 18;

export const AFFILIATE_COMPANY = {
	41: 'bnk',
	4: 'lotte',
	6: 'vancar',
	49: 'sk_rent',
	50: 'k_car',
	51: 'socar',
	18: 'hyundai_capital',
	87: 'lotte_auto_lease',
};

export const EXPIRATIONS_TXT = {
	BUY: '구매',
	RETURN: '반납',
};

export const INCLUSIONS_TXT = {
	CAR_TAX: '자동차 세금',
	INSURANCE: '보험료',
	MAINTENANCE: '정비서비스',
};
